import { useMediaQuery } from "./use-media-query";

/**
 * Whether the user has asked the OS to minimize motion. JS-side signal for
 * animation the CSS engine doesn't drive (WAAPI springs, animated chart
 * series) — CSS-driven motion uses the `motion-reduce:` variant instead.
 */
export function usePrefersReducedMotion(): boolean {
  return useMediaQuery("(prefers-reduced-motion: reduce)");
}
